import { useAchievements } from "api/achievements";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { AchievementForm } from "./AchievementForm";

export function EditAchievement() {
  const [achievementName, setAchievementName] = useState<string | undefined>();
  const { id: achievementId } = useParams<{ id: string }>();
  const { useAchievementData } = useAchievements();
  const { data: achievementData } = useAchievementData(achievementId);
  const { message } = useMessage();

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "achievements" }),
      path: links.achievementsList,
    },
  };

  return (
    <>
      <TopHeader
        title={`${message({ id: "editAchievement" })} "${
          achievementName || ""
        }"`}
        clearLink={links.achievementsList}
        breadcrumbs={breadcrumbs}
      />
      <div>
        {achievementData && (
          <AchievementForm
            isEditMode
            initialValues={achievementData}
            setAchievementName={setAchievementName}
          />
        )}
      </div>
    </>
  );
}
